/**
 * @typedef {Object} MoneyInput
 * @property {number} vr
 * @property {number} tcp
 * @property {number} [monthlyWeightedSoFar]
 * @property {number} [monthlyWeightedCap]
 *
 * @typedef {Object} MoneyBreakdown
 * @property {number} base
 * @property {boolean} [capped]
 * @property {number} [cappedBase]
 * @property {number} [overPerformanceVr]
 * @property {string[]} notes
 */

/**
 * Compute payment per case using VR × TCP and a simple monthly VR cap.
 * @param {MoneyInput} input
 * @returns {MoneyBreakdown}
 */
export function computePayment(input) {
  const notes = [];

  const vr  = Number(input?.vr);
  const tcp = Number(input?.tcp);
  const soFar = input?.monthlyWeightedSoFar == null ? null : Number(input.monthlyWeightedSoFar);
  const cap   = input?.monthlyWeightedCap == null ? null : Number(input.monthlyWeightedCap);

  if (!Number.isFinite(vr) || !Number.isFinite(tcp)) {
    return {
      base: NaN,
      capped: false,
      notes: ["Valori invalide: vr sau tcp nu sunt numerice."],
    };
  }

  const base = round2(vr * tcp);

  if (Number.isFinite(soFar) && Number.isFinite(cap)) {
    const nextTotal = soFar + vr;
    if (nextTotal > cap) {
      const allowedVr = Math.max(0, cap - soFar);
      const cappedBase = round2(allowedVr * tcp);
      const overVr = round2(vr - allowedVr);
      notes.push(
        `Cap depășit: se decontează doar ${allowedVr} VR din ${vr} VR; ${overVr} VR rămâne peste plafon.`
      );
      return { base, capped: true, cappedBase, overPerformanceVr: overVr, notes };
    }
  }

  notes.push("Fără depășire de plafon.");
  return { base, notes };
}

function round2(n) {
  return Math.round(n * 100) / 100;
}